import { useEffect, useRef } from 'react';

export const usePrevious = <T>(state: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    setTimeout(() => {
      ref.current = state;
    });
  }, [state]);

  return ref.current;
};
